import React, { useEffect, useState, useContext } from 'react';

import { fetchData } from '../../../helpers/methods';
import { CustomerContext } from '../../../contexts/customer-context';

import SpinnerContainer from '../../../component-library/spinner-container';
import TaxonomyTree from '../../../component-library/taxonomy-tree';
import Modal from '../../../component-library/modal';

import TaxonomyResults from './sub-components/taxonomy-results';

const Taxonomy = () => {
	const {
		search: {
			taxonomies: customerTaxonomyData,
		} = {},
	} = useContext(CustomerContext);
	const [loading, setLoading] = useState(true);
	const [showModal, setShowModal] = useState(false);
	const [taxonomyData, setTaxonomyData] = useState([]);
	const [classificationId, setClassificationId] = useState(null);
	const [classificationName, setClassificationName] = useState('');

	const getTaxonomies = () => {
		setLoading(true);
		const urlArray = [];
		if (customerTaxonomyData.length > 0) {
			customerTaxonomyData.forEach(entry => {
				urlArray.push(`/api/web/taxonomy/${entry.id}/data`);
			});
			Promise.all(urlArray.map(url => fetchData({
				uri: url,
				method: 'GET',
			}).then(({ ok, body }) => {
				if (ok) {
					return body;
				}
				return 'FAIL';
			})))
				.then(data => {
					if (!data.includes('FAIL')) {
						setTaxonomyData(data);
						setLoading(false);
					} else {
						setLoading(false);
					}
				})
				.catch(() => {
					setLoading(false);
				});
		} else {
			setLoading(false);
		}
	};

	const handleClassificationClick = (name, id) => {
		setClassificationName(name);
		setClassificationId(id);
		setShowModal(true);
	};

	useEffect(() => {
		getTaxonomies();
	}, []);

	return (
		<div>
			<h2>Taxonomy</h2>
			{loading && (
				<SpinnerContainer />
			)}
			{!loading && (
				taxonomyData?.length > 0 ? (
					<div className="taxonomy__grid">
						<div>
							{taxonomyData.map((taxonomy, index) => (
								// eslint-disable-next-line react/no-array-index-key
								<div className="margin-bottom-24" key={index}>
									<h3>{taxonomy.name}</h3>
									<TaxonomyTree
										classifications={taxonomy.classifications}
										handleClassificationClick={handleClassificationClick}
										selectedClassification={classificationId}
									/>
								</div>
							))}
						</div>
						<div className="taxonomy__results-container">
							<div className="taxonomy__results border">
								<TaxonomyResults
									id={classificationId}
									classificationName={classificationName}
								/>
							</div>
						</div>
					</div>
				) : (
					<p className="grey-text text-center margin-top-24 margin-bottom-none">No taxonomies found</p>
				)
			)}
			{showModal && (
				<div className="taxonomy__modal">
					<Modal
						title={classificationName}
						handleCancel={() => setShowModal(false)}
						isLarge
					>
						<TaxonomyResults
							id={classificationId}
						/>
					</Modal>
				</div>
			)}
		</div>
	);
};

export default Taxonomy;
